import { Tag } from 'antd';
import type { DriverDetail } from '../drivers.api';
import { CONSENT_COLORS, CONSENT_LABELS, CONSENT_NOTES } from '../policies/consent-labels';

/** Read-only: only the driver, in their own app, can give or take back consent (gitaumoses4/chukua#60). */
export function DriverConsentPanel({ consent }: { consent: DriverDetail['locationConsent'] }) {
  return (
    <section aria-label="Location consent" className="rounded-lg border border-line bg-surface px-4 py-3">
      <p className="text-sm font-medium text-fg">Location consent</p>
      <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted">
        <Tag className="m-0" color={CONSENT_COLORS[consent.status]}>
          {CONSENT_LABELS[consent.status]}
        </Tag>
        {consent.recordedAt && <span>since {new Date(consent.recordedAt).toLocaleString()}</span>}
        {consent.appVersion && <span>App {consent.appVersion}</span>}
      </p>
      <p className="mt-1 text-sm text-muted">{CONSENT_NOTES[consent.status]}</p>
    </section>
  );
}
